module.exports = __webpack_public_path__ + "06_bob_black.73077b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_bob_black.png
// module id = p++A
// module chunks = 0